import { render, staticRenderFns } from "./DismissWorker.vue?vue&type=template&id=c59d39ee&scoped=true&"
import script from "./DismissWorker.vue?vue&type=script&lang=js&"
export * from "./DismissWorker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59d39ee",
  null
  
)

export default component.exports